import React from "react";
import "./styles.css";
import PlanCard from "../UI/plan-card";
import { plansArray } from "../../constants/contents";

function Plans() {
  return (
    <div className="plans">
      {plansArray.map((plan) => (
        <PlanCard
          icon={plan.icon}
          title={plan.title}
          previousPricing={plan.previousPricing}
          currentPricing={plan.currentPricing}
          description={plan.description}
          features={plan.features}
          borderColor={plan.borderColor}
          titleColor={plan.titleColor}
        />
      ))}
    </div>
  );
}

export default Plans;
